import React, { useState, useEffect, useRef } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { getFetchUrl, getFetchParams } from '../../helpers'
import { useInstallPrompt } from '../../hooks/InstallPrompt'

// CSS
import '../../sass/app.sass'
import '../../sass/at-media-test.sass'

// Tranlations
import t from '../../translations'

// Components
import LanguageToggle from './components/LanguageToggle'
import BurgerModal from './components/BurgerModal'
// import Profile from './components/App/Profile'

import AllRoutes from './AllRoutes'
import Footer from './components/Footer'

// helpers
import { checkSessionToken } from '../../helpers'

// Translations
import { supportedLanguages } from '../../translations'
import Burger from './components/Burger'

export const checkServerUp = async () => {
  let serverResponse
  try{
    serverResponse = await fetch(getFetchUrl('maintenance'), {
        ...getFetchParams(),
        body: JSON.stringify({a: 'checkServer'}),
    })
  }catch(error){
      window.location.patName = 'maintenance'
  }

  if(serverResponse && serverResponse.ok){
    const response = await serverResponse.json()
    if(response.isUp && window.location.pathname === '/maintenance'){
      const returnTo = localStorage?.getItem('goBackTo') ?? '/'
      localStorage.removeItem('goBackTo')
      window.location.pathname = returnTo
    }
  }else{
    if(window.location.pathname !== '/maintenance'){
      localStorage.setItem('goBackTo', window.location.pathname)
      window.location.pathname = 'maintenance'
    }
  }
}

const App = () => {
  const [mediaTest, setMediaTest] = useState(false)

  // eslint-disable-next-line
  const noUser = {
    connected: false,
    username: '',
    sessionToken: '',
  }

  const [load, setLoad] = useState(true)

  const [pathName, setPathName] = useState('')
  const [lang, setLang] = useState(localStorage.getItem('language') ?? 'FR')
  const [user, setUser] = useState(localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : noUser)

  const [loginModalOpen, setLoginModalOpen] = useState(false)
  const [burgerModalOpen, setBurgerModalOpen] = useState(false)

  // SessionToken interval check
  const sessionTokenCheckMinutes = 10
  const sessionTokenCheckMs = 1000 * 60 * sessionTokenCheckMinutes
  const sessionTokenCheckMs_normalUser = 1000 * 60 * 1
  const [sessionInterval, setSessionInterval] = useState()

  // eslint-disable-next-line
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    if(window.location.pathname !== '/maintenance'){
      checkServerUp()
    }
    setTimeout(() => {
      setLoad(false)      
    }, 800)
  }, [])

  useEffect(() => {
    const sessiontokenExist = user?.sessionToken
    
    if (sessiontokenExist && !sessionInterval) {

      checkSessionToken(user, setUser, checkServerUp, noUser)

      // Check over time
      setSessionInterval(
        setInterval(() => {
          ;(async () => {
            await checkSessionToken(user, setUser, checkServerUp, noUser)
          })()
        }, user.level <= 10 ? sessionTokenCheckMs_normalUser : sessionTokenCheckMs)
      )
    } else if (!sessiontokenExist && sessionInterval) {
      clearInterval(sessionInterval)
    }
  }, [load, user, noUser, sessionInterval, sessionTokenCheckMs, sessionTokenCheckMs_normalUser])

  useEffect(() => {
    const urlLang = searchParams.get('lang')
    if (urlLang) {
      setLang(supportedLanguages.includes(urlLang) ? urlLang : 'FR')
    }

    setMediaTest(searchParams.get('media') === 'true')
  }, [searchParams])

  const getLinkTitles = ((lang, key) => t[lang].subnav[key])
  const getLoginButtonText = ((lang, isconnected) => t[lang][isconnected ? 'disconnected' : 'connected'])
  const getRegisterButtonText = ((lang, isconnected) => t[lang][`register ${isconnected ? 'out' : 'in'}`])

  const getLink = (path) => (
    <Link to={`/${path}/`}
      className={pathName === `/${path}/` || (path === 'career' && pathName === '/') ? 'menuItemActive' : ''}
      onClick={() => setPathName(`/${path}/`)}
    >
      {getLinkTitles(lang, path)}
    </Link>
  )

  const burgerRef = useRef(null)
  const handleBurger = () => {
    setBurgerModalOpen((previousState) => !previousState)
    setLoginModalOpen(false)
  }

  const installButton = useInstallPrompt(lang)
  
  return (
    <>
      <nav className='nav mainNav'>
        <div className='user'>
          <span className='appName'>
            <Link to='/' onClick={() => setPathName(`/`)}>Incoherences.org</Link>
          </span>
          {user.connected && <div className='navUsername'>&#10132;&nbsp;{user.username}</div>}
        </div>

        <div className='language'>
          <LanguageToggle
            lang={lang}
            setLang={setLang}
          />
        </div>

        <div className='burger'>
          <Burger
            burgerModalOpen={burgerModalOpen}
            handleBurger={handleBurger}
            lang={lang}
          />
        </div>

      </nav>

      <div className='nav subNav'>
        {getLink('what')}
        {user.level >= 10 ? getLink('todo') : ''}
        {user.level >= 50 ? getLink('expenses') : ''}
      </div>

      {!load && <AllRoutes installButton={installButton} lang={lang} user={user} setUser={setUser} checkServerUp={checkServerUp} noUser={noUser} loginModalOpen={loginModalOpen} />}
      <Footer lang={lang} />

      <BurgerModal
        ref={burgerRef}
        burgerModalOpen={burgerModalOpen}
        handleBurger={handleBurger}
        load={load}

        lang={lang}
        setLang={setLang}
        getLoginButtonText={getLoginButtonText}
        getRegisterButtonText={getRegisterButtonText}
        user={user}
        setUser={setUser}
        setLoginModalOpen={setLoginModalOpen}
      />

      {mediaTest && <div className='breakpoint-test'>
        <div className='xxs_h'>xxs (h)</div>
        <div className='xs_h'>xs (h)</div>
        <div className='md_h'>md (h)</div>
        <div className='lg_h'>lg (h)</div>
        <div className='xlg_h'>xlg (h)</div>
        <div className='xxlg_h'>xxlg (h)</div>

        <div className='xxs_v'>xxs (v)</div>
        <div className='xs_v'>xs (v)</div>
        <div className='md_v'>md (v)</div>
        <div className='lg_v'>lg (v)</div>
        <div className='xlg_v'>xlg (v)</div>
        <div className='xxlg_v'>xxlg (v)</div>
      </div>}

      <div id='dragImages' />
    </>)
}

export default App
